export const TRACKING_REQUEST = 'TRACKING_REQUEST'
export const TRACKING_SUCCESS = 'TRACKING_SUCCESS'
export const TRACKING_FAIL = 'TRACKING_FAIL'
